import { Breadcrumb, BreadcrumbSeparator } from "./Breadcrumb.styles";
import ContentLoader from "react-content-loader";
import useCoreContext from "@gf-core/widgets/hooks/useCoreContext";
import { ArrowIndicatorRightOutlined } from "@gds-react/icons";

export default function BreadCrumbLoader() {
  const { theme } = useCoreContext();
  return (
    <Breadcrumb>
      <ContentLoader
        speed={1.2}
        backgroundColor={theme.core.colors.background.layers[700]}
        foregroundColor={theme.core.colors.background.layers[500]}
        style={{
          width: 80,
          height: 16,
        }}
      >
        <rect x="0" width="80" rx={4} height="16px" />
      </ContentLoader>
      <BreadcrumbSeparator>
        <ArrowIndicatorRightOutlined />
      </BreadcrumbSeparator>
      <ContentLoader
        speed={1.2}
        backgroundColor={theme.core.colors.background.layers[700]}
        foregroundColor={theme.core.colors.background.layers[500]}
        style={{
          width: 80,
          height: 16,
        }}
      >
        <rect x="0" width="80" rx={4} height="16px" />
      </ContentLoader>
      <BreadcrumbSeparator>
        <ArrowIndicatorRightOutlined />
      </BreadcrumbSeparator>
      <ContentLoader
        speed={1.2}
        backgroundColor={theme.core.colors.background.layers[700]}
        foregroundColor={theme.core.colors.background.layers[500]}
        style={{
          width: 80,
          height: 16,
        }}
      >
        <rect x="0" width="80" rx={4} height="16px" />
      </ContentLoader>
    </Breadcrumb>
  );
}
